import React, { useCallback, useState, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';

const RichTextEditor = ({ name, value, onChange, label, placeholder, enableMediaContent = false }) => {
  const [content, setContent] = useState(value || "");

  useEffect(() => {
    setContent(value || "");
  }, [value]);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || 'Inserisci il testo...',
      language: "it",
      toolbarButtonSize: "medium",
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: true,
      askBeforePasteFromWord: true,
      height: 300,
      buttons: [
        'undo', 'redo', '|',
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'superscript', 'subscript', '|',
        'align', '|',
        'ul', 'ol', 'outdent', 'indent', '|',
        'font', 'fontsize', 'brush', 'paragraph', '|',
        'image', 'link', 'table', '|',
        'hr', 'eraser', 'copyformat', '|',
        'fullsize', 'selectall', 'print', '|',
        'source'
      ],
      uploader: {
        insertImageAsBase64URI: true,
      },
      image: {
        dialogWidth: 500,
        useImageEditor: true,
        selectImageAfterUpload: true,
        defaultWidth: 300,
        accept: ['jpg', 'png', 'jpeg', 'gif'],
        dragAndDropEnabled: true
      }
    }),
    [placeholder]
  );

  const handleBlur = useCallback(
    (newContent) => {
      setContent(newContent);
      onChange({
        target: {
          name: name,
          value: newContent
        }
      });
    },
    [onChange, name]
  );

  const handleChange = useCallback(
    (newContent) => {
      setContent(newContent);
    },
    []
  );

  return (
    <div className='col-12 mt-2'>
      {label && <span className="d-block text-muted mb-2"><b>{label}</b></span>}
      <div className="jodit-wrapper">
        <JoditEditor
          value={content}
          config={config}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default RichTextEditor;
